import {
  getGitCode,
  storeGitCode
} from '@/firebase/databaseDependencyInjectables';
import { app } from '@/firebase/init';
import { getURL } from '@/modules/globalModule/components/helperMethods';
import { Octokit } from '@octokit/core';
import { getFunctions, httpsCallable } from 'firebase/functions';

/**
 * gets the git authorisation code from the backend.
 * if the code has expired, uses the refresh token to get a new code
 * if the refresh token as also expired, or there is no code in the database,
 * opens up the git authentication window and returns undefined.
 * @param workspaceId - only used for opening the git authentication menu
 * @returns
 */
export const gitAuthorization = async (
  workspaceId: string
): Promise<GitTokenDetails | undefined> => {
  const gitTokenDetails = getGitCode();
  if (
    gitTokenDetails &&
    gitTokenDetails.access_token &&
    gitTokenDetails.dateObtained
  ) {
    if (
      Math.floor(Date.now() / 1000) - gitTokenDetails.dateObtained <
      parseInt(gitTokenDetails.expires_in)
    ) {
      return gitTokenDetails;
    }
    if (
      Math.floor(Date.now() / 1000) - gitTokenDetails.dateObtained <
      parseInt(gitTokenDetails.refresh_token_expires_in)
    ) {
      const gitAuth = httpsCallable(getFunctions(app), 'git_auth_refresh');
      const refreshRes = await gitAuth({
        refresh_token: gitTokenDetails.refresh_token
      });
      const refreshTokenDetails: GitTokenDetails = {
        ...(refreshRes.data as any),
        dateObtained: Math.floor(Date.now() / 1000) // seconds
      };
      storeGitCode(refreshTokenDetails);
      return refreshTokenDetails;
    }
  }
  open(
    `https://github.com/login/oauth/authorize?client_id=Iv1.30a75b3dc379cc87&redirect_uri=${getURL()}/controlCenter/${workspaceId}/git`,
    '_blank'
  );
  return undefined;
};

export const getUserDetails = async (token: string) => {
  const octokit = new Octokit({ auth: token });
  const userDetails = await octokit.request('GET /user', {
    headers: {
      'X-GitHub-Api-Version': '2022-11-28'
    }
  });
  return userDetails.data;
};

export const checkUserInstalledMirosApp = async (token: string) => {
  const octokit = new Octokit({
    auth: token
  });

  const res = await octokit.request('GET /user/installations', {
    headers: {
      'X-GitHub-Api-Version': '2022-11-28'
    }
  });
  if (
    res.data.installations.find(
      (appInstallation) => appInstallation.app_id === 854099
    )
  )
    return true;
  return false;
};

export interface GitTokenDetails {
  access_token: string;
  expires_in: string;
  refresh_token: string;
  refresh_token_expires_in: string;
  token_type: string;
  scope: string;
  dateObtained?: number;
}
